import React, { useMemo } from "react";
import { ITickets } from "app/containers/Features/containers/Boards/containers/Tickets/types";
import { AttachmentType } from "app/containers/Features/types";
import Attachments from "./Attachments";
import CheckList from "./CheckList";
import Description from "./Description";
import Relations from "./Relations";

interface TicketActionsProps {
  ticket: ITickets;
  status: string;
}

const TicketActions: React.FC<TicketActionsProps> = ({ ticket, status }) => {
  const {
    hasDescription,
    hasRelations,
    attachmentsCount,
    hasChecklist,
    attachments,
  } = useMemo(() => {
    const hasDescription = Boolean(
      ticket?.description?.content &&
      ticket.description.content?.trim().length > 0,
    );

    const hasRelations =
      Array.isArray(ticket?.relations) &&
      ticket.relations.some(
        (item) =>
          item != null &&
          typeof item === "object" &&
          typeof item._id === "string" &&
          item.ticket != null,
      );

    const attachmentsArray = Array.isArray(ticket?.attachments)
      ? (ticket.attachments as AttachmentType[])
      : ([] as AttachmentType[]);
    const attachmentsCount = attachmentsArray.length;

    const hasChecklist =
      Array.isArray(ticket?.actionItems) &&
      ticket.actionItems.some(
        (item) =>
          item != null &&
          typeof item === "object" &&
          typeof item._id === "string",
      );

    return {
      hasDescription,
      hasRelations,
      attachmentsCount,
      hasChecklist,
      attachments: attachmentsArray,
    };
  }, [ticket]);

  if (
    !hasDescription &&
    !hasRelations &&
    attachmentsCount === 0 &&
    !hasChecklist
  ) {
    return null;
  }

  return (
    <div className="flex flex-row items-center justify-start gap-[4px] p-[6px] shrink-0">
      {hasDescription && <Description description={ticket?.description} />}

      {hasRelations && <Relations data={ticket} />}

      {attachmentsCount > 0 && (
        <Attachments count={attachmentsCount} attachments={attachments} />
      )}

      {hasChecklist && <CheckList data={ticket} status={status} />}
    </div>
  );
};

export default TicketActions;
